import { AH_BORDER, AH_MUTED, AH_WHITE } from "../Compliance/AuditHub/theme";

/** White bordered table card — same shell as ProgramsGrid. */
export const formTableCardSx = {
  border: `1px solid ${AH_BORDER}`,
  borderRadius: "12px",
  backgroundColor: AH_WHITE,
  overflow: "hidden",
};

/** Header cells — same treatment as ProgramsGrid / Audit Hub AuditsTable. */
export const formTableHeadCellSx = {
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "0.04em",
  color: AH_MUTED,
  backgroundColor: AH_WHITE,
  borderBottom: `1px solid ${AH_BORDER}`,
  whiteSpace: "nowrap",
  lineHeight: 1.25,
  py: 1.25,
  px: 0.75,
  textAlign: "center",
};

/** Body cells — same treatment as ProgramsGrid. */
export const formTableBodyCellSx = {
  fontSize: "0.8125rem",
  fontWeight: 500,
  lineHeight: 1.4,
  color: "#334155",
  borderBottom: `1px solid ${AH_BORDER}`,
  py: 1.5,
  px: 0.75,
  verticalAlign: "middle",
  textAlign: "center",
};

export const formTableActionBtnSx = {
  width: 30,
  height: 30,
  borderRadius: "8px",
  border: "1px solid #e2e8f0",
  backgroundColor: "#f8fafc",
  color: "#64748b",
  padding: 0,
  flexShrink: 0,
  "&:hover": {
    backgroundColor: "#f1f5f9",
    color: "#334155",
  },
  "&.Mui-disabled": {
    color: "#cbd5e1",
    borderColor: "#f1f5f9",
    backgroundColor: "#f8fafc",
  },
};

export const formTableDeleteBtnSx = {
  ...formTableActionBtnSx,
  color: "#dc2626",
  borderColor: "#fecaca",
  backgroundColor: "#fef2f2",
  "&:hover": {
    backgroundColor: "#fee2e2",
    color: "#991b1b",
  },
  "&.Mui-disabled": {
    color: "#fca5a5",
    borderColor: "#fee2e2",
    backgroundColor: "#fff",
  },
};

export const formTableActionsWrapSx = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0.5,
  width: "100%",
};
